import axios from 'axios';
import { UserPlus } from 'lucide-react';

import { CONFIG } from '../../../../constants';
import { toTitleCase } from '../../../../utils/Helpers';
import apiService from '../../../../services/api.service';

export const formateNumber = value =>
  Math.round(Number(parseFloat(isNaN(value || 0) ? 0 : value || 0)) * 100) /
  100; /* Number formatting with rounding */

export const quotesBreadcrumb = (
  customerId,
  opportunityId,
  opportunityNumber = undefined,
  customerName,
  quoteNumber = undefined
) => {
  return [
    {
      label: 'Clients',
      url: `/project/clients`,
      icon: UserPlus,
    },
    {
      label: toTitleCase(customerName),
      url: `/crm/view/customer/${customerId}`,
    },
    {
      label: 'Opportunity',
      url: `/crm/view/customer/${customerId}`,
    },
    ...(opportunityNumber
      ? [
          {
            label: `${opportunityNumber}`,
            url: `/crm/${customerId}/opportunity/view/${opportunityId}`,
          },
        ]
      : []),
    {
      label: 'Quotes',
      url: `/crm/${customerId}/quotes/${opportunityId}`,
    },
    ...(quoteNumber
      ? [
          {
            label: `${quoteNumber}`,
          },
        ]
      : []),
  ];
};

export const createQuote = async payload => {
  let url = `${CONFIG?.API_CRM_URL}/api/${payload?.customerId}/${payload?.opportunityId}/quote/create `;
  return await axios.post(url, payload);
};

export const getQuoteById = async (customerId, opportunityId, id) => {
  let url = `${CONFIG?.API_CRM_URL}/api/${customerId}/${opportunityId}/quote/${id} `;
  return await axios.get(url);
};

export const mapCopyConfigurationToOptions = copyConfiguration => {
  if (!copyConfiguration || typeof copyConfiguration !== 'object') {
    return {
      copyNotes: true,
      copyPhotos: true,
      copyDocuments: true,
    };
  }

  const isEnabled = value => value === true || value === 1 || value === '1';

  const getValue = (...keys) => {
    for (const key of keys) {
      if (copyConfiguration[key] !== undefined) {
        return copyConfiguration[key];
      }
    }
    return undefined;
  };

  return {
    copyNotes:
      getValue('isCopyNotes', 'copy_notes', 'copyNotes') === undefined
        ? true
        : isEnabled(getValue('isCopyNotes', 'copy_notes', 'copyNotes')),
    copyPhotos:
      getValue('isCopyPhotoes', 'copy_photos', 'copyPhotos') === undefined
        ? true
        : isEnabled(getValue('isCopyPhotoes', 'copy_photos', 'copyPhotos')),
    copyDocuments:
      getValue('isCopyDocument', 'copy_documents', 'copyDocuments') ===
      undefined
        ? true
        : isEnabled(
            getValue('isCopyDocument', 'copy_documents', 'copyDocuments')
          ),
  };
};

export const mapOptionsToCopyConfigApiPayload = options => ({
  isCopyNotes: Boolean(options.copyNotes),
  isCopyPhotoes: Boolean(options.copyPhotos),
  isCopyDocument: Boolean(options.copyDocuments),
});

export const mapOptionsToCopyConfiguration = options => ({
  copy_notes: options.copyNotes ? 1 : 0,
  copy_photos: options.copyPhotos ? 1 : 0,
  copy_documents: options.copyDocuments ? 1 : 0,
});

export const updateQuote = async (payload, quoteId) => {
  let url = `${CONFIG?.API_CRM_URL}/api/${payload?.customerId}/${payload?.opportunityId}/quote/${quoteId} `;
  return await axios.put(url, payload);
};

const appendCountryQuery = (url, country) => {
  if (!country) {
    return url;
  }

  return `${url}&country=${encodeURIComponent(country)}`;
};

export const previewQuote = async (
  customerId,
  opportunityId,
  quoteId,
  type,
  country
) => {
  let url = `${CONFIG?.API_CRM_URL}/api/${customerId}/${opportunityId}/quote/preview/${quoteId}?type=${type}`;
  url = appendCountryQuery(url, country);
  return await axios.get(url);
};

export const sendQuote = async (
  customerId,
  opportunityId,
  quoteId,
  type,
  payload = {},
  country
) => {
  let url = `${CONFIG?.API_CRM_URL}/api/${customerId}/${opportunityId}/quote/send/${quoteId}?type=${type}`;
  url = appendCountryQuery(url, country);
  return await axios.post(url, payload);
};

export const downloadQuote = async (
  customerId,
  opportunityId,
  quoteId,
  type,
  country
) => {
  let url = `${CONFIG?.API_CRM_URL}/api/${customerId}/${opportunityId}/quote/download/${quoteId}?type=${type}`;
  url = appendCountryQuery(url, country);
  return await axios.get(url);
};

export const putTurnOnTime = async (leadId, quoteId, projectId) => {
  return await apiService.getWithDiffBaseUrl(
    `/api/update-turn-time`,
    {
      leadId,
      quoteId,
      projectId,
    },
    CONFIG?.API_CRM_URL
  );
};
export const getTermsList = async (query, quoteId, selectedId) => {
  const params = new URLSearchParams({ tag: 'QUOTE' });

  if (quoteId) params.append('quoteId', quoteId);
  if (query) params.append('search', query);
  if (selectedId) params.append('selectedId', selectedId);
  return await apiService.getWithDiffBaseUrl(
    `/api/terms-conditions/list?${params.toString()}`,
    {},
    CONFIG?.API_CRM_URL
  );
};

export const addTerms = async payload => {
  let url = `${CONFIG?.API_CRM_URL}/api/create/terms-conditions`;
  return await axios.post(url, payload);
};

export const updateTerms = async (termId, payload) => {
  let url = `${CONFIG?.API_CRM_URL}/api/update/terms-conditions/${termId}`;
  return await axios.put(url, payload);
};

export const isAddressAvailable = address =>
  Boolean(
    address &&
      (address.address_id ||
        (typeof address.address1 === 'string' && address.address1.trim()) ||
        (typeof address.full_address === 'string' &&
          address.full_address.trim()))
  );
